import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import axios from 'axios';

import logo from "../assets/images/logo.png";

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_STRAPI_API_URL}/service-articles?populate=*`, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
        },
      })
      .then((res) => {
        setServices(res.data.data);
      })
      .catch((err) => console.error(err));
  }, []);


  return (
    <header
      className={`w-full top-0 left-0 z-50 transition-none ${
        isSticky ? "fixed bg-white shadow-md text-black" : "absolute bg-transparent text-white"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <img src={logo} alt="Logo" className="h-12" />
        </div>

        <nav className="hidden md:flex space-x-6 font-semibold relative">
          <Link to="/" className="hover:text-yellow-400">Trang chủ</Link>
          <Link to="/gioi-thieu" className="hover:text-yellow-400">Giới thiệu</Link>
          
          <div
            className="relative group cursor-pointer"
            onMouseEnter={() => setIsServiceOpen(true)}
            onMouseLeave={() => setIsServiceOpen(false)}
          >
            <div className="flex items-center hover:text-yellow-400">
              <span>Dịch vụ</span>
              {isServiceOpen ? (
                <FaAngleUp className="ml-1" />
              ) : (
                <FaAngleDown className="ml-1" />
              )}
            </div>

            {isServiceOpen && (
              <div className="absolute top-full left-0 bg-white text-black rounded shadow-lg w-48">
                
                {services.map((service) => (
                  <div
                    key={service.id}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => navigate(`/dich-vu/${service.slug}`)}
                  >
                    {service.title}
                  </div>
                ))}
              </div>
            )}
          </div>

          <Link to="/contact-us" className="hover:text-yellow-400">Liên hệ</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
